module.exports = __webpack_public_path__ + "media/images/Canada-bride-image1-4daed1a9c30ae9813648d8352dc31dab.jpg";